<template>
  <div class="w-full container-EXPONDO">
    <SkeletonLoader
      v-if="isLoading"
      class="lg:px-60"
      item-classes="mt-8"
      :number-of-items="4"
      height="12px"
    />
    <div class="pp-container pt-0 lg:pt-16 pb-16" />
  </div>
</template>

<script lang="ts">


export default defineComponent({
  name: 'Tracking',
  setup() {

    const { isLoading } = useParcelPerform();

    return {
      isLoading,
    };
  
  },
});

</script>
